













































































































































































































































































































import Vue from "vue";
import AdvertisementPreview from "@/components/Form/AdvertisementPreview.vue";
import MessageBoxList from "@/components/MessageBoxList.vue";
import { Advertisement } from "@/interfaces/advertisement";
import { MediaObject } from "@/interfaces/mediaobject";
import IssueInvoiceButton from "@/components/Button/IssueInvoiceButton.vue";
import IssueReceiptButton from "@/components/Button/IssueReceiptButton.vue";
import PaymentButton from "@/components/Button/PaymentButton.vue";
import SuspendAdvertisementButton from "@/components/Button/SuspendAdvertisementButton.vue";
import ResumeAdvertisementButton from "@/components/Button/ResumeAdvertisementButton.vue";
import GeneratePreviewTokenButton from "@/components/Button/GeneratePreviewTokenButton.vue";
import ExpandPublishmentButton from "@/components/Button/ExpandPublishmentButton.vue";
// import Api from "@/api/Api";
// const api = Api.singleton();
export default Vue.extend({
  components: {
    AdvertisementPreview,
    MessageBoxList,
    IssueInvoiceButton,
    IssueReceiptButton,
    PaymentButton,
    SuspendAdvertisementButton,
    ResumeAdvertisementButton,
    GeneratePreviewTokenButton,
    ExpandPublishmentButton
  },
  methods: {
    async loadAdvertisement() {
      this.advertisement = await this.$store.dispatch(
        "reloadResource",
        "/api/adv/posts/" + this.$route.params.id
      );
      for (const i of [1, 2, 3, 4, 5]) {
        const k = ("image" + i) as
          | "image1"
          | "image2"
          | "image3"
          | "image4"
          | "image5";
        if (!this.advertisement.eyeCatch) {
          continue;
        }
        if (!this.advertisement[k]) {
          continue;
        }
        const eyeCatchId = this.advertisement.eyeCatch["@id"];
        const imageId = (this.advertisement[k] as MediaObject)["@id"];
        if (eyeCatchId == imageId) {
          this.$set(this.advertisement, "eyecatchIndex", i);
        }
      }
      this.mbKey = Symbol();
      this.$forceUpdate();
    },
    async movePublishScreenWithDuplicated(duplicated: Advertisement) {
      if (duplicated.id) {
        this.$router.push({
          name: "AdvertiserAdvertisementsPublishment",
          params: { id: duplicated.id },
          query: { nextto: this.advertisement.id }
        });
      }
    },
    clip(el: HTMLInputElement) {
      el.select();
      document.execCommand("copy");
    }
  },
  data() {
    return {
      advertisement: {} as Advertisement,
      mbKey: Symbol(),
      cardStatus: "initial"
    };
  },
  async mounted() {
    await this.loadAdvertisement();
    this.$nextTick(() => {
      (this.$refs.message as Element).scrollTop = (this.$refs
        .message as Element).scrollHeight;
    });
  },
  computed: {
    isPage() {
      return true;
    },
    previewUrl(): string {
      if (this.advertisement.previewToken) {
        return (
          window.location.origin +
          "/preview/" +
          this.advertisement.id +
          "/" +
          this.advertisement.previewToken
        );
      } else {
        return "(未設定)";
      }
    }
  }
});
